module.exports = __webpack_public_path__ + "img/pin-perola.56650851.png";